export enum AuthModalMode {
  REGISTER = 'REGISTER',
  LOGIN = 'LOGIN',
}
